import React from 'react';
import { 
  Container, 
  Grid, 
  Card, 
  CardContent, 
  Typography, 
  CardActionArea,
  Box,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { 
  EmojiEvents as TrophyIcon,
  Store as StoreIcon,
} from '@mui/icons-material';
import PageTitle from '../../components/PageTitle';

const TorneosPage = () => {
  const navigate = useNavigate();

  const sections = [
    {
      title: 'Ranking General',
      description: 'Ver el ranking general de todos los jugadores',
      icon: TrophyIcon,
      path: '/torneos/general',
      color: '#c89e38',
    },
    {
      title: 'Ranking por Tienda',
      description: 'Ver el ranking de jugadores por tienda',
      icon: StoreIcon,
      path: '/torneos/tiendas',
      color: '#c89e38',
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <PageTitle title="Torneos" />
      
      <Grid container spacing={3} sx={{ mt: 1 }}>
        {sections.map((section) => (
          <Grid item xs={12} sm={6} key={section.title}>
            <Card 
              elevation={0}
              sx={{ 
                height: '100%',
                border: '1px solid',
                borderColor: 'divider',
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                }
              }}
            >
              <CardActionArea 
                onClick={() => navigate(section.path)}
                sx={{ height: '100%' }}
              >
                <CardContent sx={{ height: '100%' }}>
                  <Box 
                    sx={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      mb: 2 
                    }}
                  >
                    <section.icon 
                      sx={{ 
                        fontSize: 40, 
                        color: section.color,
                        mr: 2 
                      }} 
                    />
                    <Typography variant="h6" component="div">
                      {section.title}
                    </Typography>
                  </Box>
                  <Typography variant="body2" color="text.secondary">
                    {section.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default TorneosPage; 